export const FETCH_PUBLIC_ACTION = 'FETCH_PUBLIC_ACTION';
export const SUBSCRIBE_NEWSLETTER = 'SUBSCRIBE_NEWSLETTER';
export const FETCH_HP_SLIDES = 'FETCH_HP_SLIDES';
export const SET_HAS_SHOWN_ALERTS_ACTION = 'SET_HAS_SHOWN_ALERTS_ACTION';
